import { formatISO as fnsFormatISO } from 'date-fns/formatISO'
import { asISODate } from 'lib/helpers/asISODate/asISODate'
import { isValidDate } from 'lib/helpers/isValidDate/isValidDate'

export const formatDateToISO = (date: Maybe<Date>): Maybe<ISODate> => {
  if (!isValidDate(date)) {
    return null
  }

  return asISODate(fnsFormatISO(date, { representation: 'date' }))
}
